export var isEligibilityPending = function isEligibilityPending(eligibility) {
  return !(eligibility !== null && eligibility !== void 0 && eligibility.status) || eligibility.status === 'ready_to_verify';
};
//# sourceMappingURL=isEligibilityPending.js.map